import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss']
})
export class NotificationMessageComponent {
  @Input() body = '';
  @Input() maxLines = 3;
  @Input() messageId = 'notification-message';
  @Input() expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  private readonly toggleThreshold = 120;

  get showToggle(): boolean {
    return (this.body || '').length > this.toggleThreshold;
  }

  toggleExpanded(event: Event): void {
    event.stopPropagation();
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
